<template>
    <div class="lb">
        <div class="text-area" ref="content" @mouseenter="mouseenterEvent()" @mouseleave="mouseleaveEvent()">
            <div class="list-content" ref="scroll1">
                <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
                    <div class="lt-left-title">
                        <p>{{ item.value3 }}</p>
                    </div>
                    <div class="lt-left-head">
                        <div class="icon"></div>
                        <div class="area-title">
                            <div>{{ item.value2 }}</div>
                            ({{ item.value1 }})
                        </div>
                    </div>
                    <div class="bottom-area">
                        <div class="line"></div>
                        <div class="bottom-active" :title="`${item.value3}%`" :style="{
                            width: (+item.value3 / +scopelist[0].value3) * 100 + '%',
                        }">
                            <div class="bottom-border"></div>
                        </div>
                    </div>
                    <div class="bottom-area2">
                        <div class="line"></div>
                    </div>
                </div>
            </div>
            <div class="list-content" ref="scrol21" v-if="scopelist && scopelist.length > 4">
                <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
                    <div class="lt-left-title">
                        <p>{{ item.value3 }}</p>
                    </div>
                    <div class="lt-left-head">
                        <div class="icon"></div>
                        <div class="area-title">
                            <div>{{ item.value2 }}</div>
                            ({{ item.value1 }})
                        </div>
                    </div>
                    <div class="bottom-area">
                        <div class="line"></div>
                        <div class="bottom-active" :title="`${item.value3}%`" :style="{
                            width: (+item.value3 / +scopelist[0].value3) * 100 + '%',
                        }">
                            <div class="bottom-border"></div>
                        </div>
                    </div>
                    <div class="bottom-area2">
                        <div class="line"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope79",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: "scope79-新数值条形图-完成",
            timer: null,
            defaultdata: [
                { value1: "单位:%", value2: "系列一", value3: "100" },
                { value1: "单位:%", value2: "系列二", value3: "70" },
                { value1: "单位:%", value2: "系列三", value3: "50" },
                { value1: "单位:%", value2: "系列四", value3: "30" },
                { value1: "单位:%", value2: "系列五", value3: "30" },
                { value1: "单位:%", value2: "系列六", value3: "30" },
            ],
            valueMap: [
                { name: "单位", key: "value1" },
                { name: "名称", key: "value2" },
                { name: "数值", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            scopelist: [],
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.Drawdata();
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        ...methods,
        rollUp(t) {
            const ulf1 = this.$refs.scroll1;
            const box = this.$refs.content;
            if (ulf1.offsetHeight > 200) {
                box.scrollTop = 0;
                this.timer = window.setInterval(this.rollStart, t);
            }
        },
        rollStart() {
            const ulf1 = this.$refs.scroll1;
            const box = this.$refs.content;
            if (box.scrollTop >= ulf1.scrollHeight) {
                box.scrollTop = 0;
            } else {
                box.scrollTop += 2;
            }
        },
        mouseenterEvent() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        mouseleaveEvent(t) {
            if (!this.timer) {
                this.timer = setInterval(this.rollStart, 150);
            }
        },
        Drawdata() {
            let linedata = JSON.parse(JSON.stringify(this.defaultdata));
            linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10);
            this.scopelist = linedata;
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.Drawdata(); //需要刷新的数据
        this.$nextTick(() => {
            this.rollUp(150);
        });
    },
};
</script>

<style scoped lang="scss">
.lb {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;
    overflow: hidden;
}

.lt-left-item {
    width: 435px;
    height: 55px;
    margin-bottom: 5px;
    // background: #000;
    position: relative;
}

.lt-left-title {
    position: absolute;
    // left: 10px;
    // top: 26px;
    right: 30px;
    // top: 26px;

    p {
        font-family: Benmo Ziyu;
        font-weight: 400;
        font-size: 15px;
        color: #dbf4ff;
        line-height: 30px;
    }
}

.lt-left-head {
    position: absolute;
    // left: 94px;
    left: 10px;
    top: -5px;
    // width: 160px;
    display: flex;
    align-items: center;

    .icon {
        width: 20px;
        height: 20px;
        background: url("@/assets/temimg2/scope36-icon.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 8px;
    }

    // align-items: center;
    .area-title {
        display: flex;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #4b7ecd;
        line-height: 30px;
        letter-spacing: 2px;

        div {
            display: inline-block;
            max-width: 160px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .head-value {
        margin-left: auto;
        color: #faec00;
    }
}

.bottom-area {
    position: absolute;
    // left: 90px;
    left: 14px;
    top: 28px;
    width: 400px;
    background: #223d66;
    // border-radius: 10px;
    height: 15px;
    position: relative;

    .line {
        position: absolute;
        left: -8px;
        top: 0px;
        width: 4px;
        height: 15px;
        background: #137cfc;
    }

    .bottom-active {
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .bottom-border {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-right: 3px solid #c0dbff;
        animation: name duration timing-function delay iteration-count direction fill-mode;
        background: linear-gradient(to right, #1f6397, #119ce0 60%, #0da3e8);
        animation: borderactive 7.5s infinite linear;
    }
}

.bottom-area2 {
    // position: absolute;
    left: 260px;
    top: 13px;
    width: 160px;
    // background: #223d66;
    border-radius: 10px;
    height: 15px;
    position: relative;

    .line {
        position: absolute;
        right: -4px;
        top: 0px;
        width: 4px;
        height: 15px;
        background: #137cfc;
    }

    .bottom-active {
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .bottom-border {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-right: 3px solid #c0dbff;
        animation: name duration timing-function delay iteration-count direction fill-mode;
        background: linear-gradient(to right, #378580, #54e6a0 60%, #5affa4);
        animation: borderactive 7.5s infinite linear;
    }
}

.lt-left-item:nth-child(1) {
    .bottom-area {
        .bottom-border {
            background: linear-gradient(to right, #378580, #48c093 30%, #5affa4);
        }
    }
}

@keyframes borderactive {
    0% {
        width: 0%;
    }

    33% {
        width: 100%;
    }

    100% {
        width: 100%;
    }
}

.text-area {
    height: 240px;
    pointer-events: auto;
    width: 100%;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 0;
    }
}
</style>